module.exports = __webpack_public_path__ + "static/img/homes6.627ab9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/images/home/homes6.png
// module id = Qy9V
// module chunks = 2